import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'

import profile from './profile'
import videos from './videos'

export default  (history) =>
    combineReducers({
        profile,
        videos,
        router: connectRouter(history)
    });
